import React from 'react'
import { useTranslation } from 'react-i18next'

import { StyledWellnessAccordion as S } from './WellnessAccordion.styles'

type TProps = {
  children: React.ReactNode
  className?: string
  isOpen?: boolean
  titleKey: string
}

export const WellnessAccordion: React.FC<TProps> = ({
  children,
  className,
  isOpen = false,
  titleKey,
}) => {
  const { t } = useTranslation()

  return (
    <S.Item className={className} open={isOpen}>
      <S.Title>{t(titleKey)}</S.Title>
      <S.Body>{children}</S.Body>
    </S.Item>
  )
}
